
import Header from "@/components/Header";

const StrategyLoading = () => {
  return (
    <div className="min-h-screen bg-[#F5F7FB] flex items-center justify-center">
      <Header />
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#517FA4] mx-auto"></div>
        <p className="mt-4 text-[#517FA4]">Checking subscription status...</p>
      </div>
    </div>
  );
};

export default StrategyLoading;
